document.addEventListener('DOMContentLoaded', init);
document.addEventListener('cart:updated', applyDefaultAddressIfNeeded);

let defaultApplied = false;
let activeLineKeyForModal = null;

function init() {
  applyDefaultAddressIfNeeded();

  document.addEventListener('change', (e) => {
    if (e.target.matches('.cart-item-address__select')) {
      onAddressChange(e);
    }
  });

  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest('[data-open-address-modal]');
    if (addBtn) {
      openModal(addBtn.dataset.lineKey);
      return;
    }

    if (e.target.closest('#address-modal-close') || e.target.closest('#address-modal-cancel')) {
      closeModal();
      return;
    }

    if (e.target.closest('#address-modal-save')) {
      onSaveModalAddress();
      return;
    }

    if (e.target.id === 'address-modal-overlay') {
      closeModal();
    }
  });
}

async function applyDefaultAddressIfNeeded() {
  if (defaultApplied) return;
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();

  let defaultAddress = cart.attributes.default_ship_to
    ? JSON.parse(cart.attributes.default_ship_to)
    : window.customerDefaultAddress;

  if (!defaultAddress) { defaultApplied = true; return; }

  if (!cart.attributes.default_ship_to) {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { default_ship_to: JSON.stringify(defaultAddress) } })
    });
  }

  for (const item of cart.items) {
    if (!item.properties || !item.properties._ship_address_id) {
      await setLineAddress(item.key, defaultAddress);
    }
  }
  defaultApplied = true;
}

function onAddressChange(e) {
  const select = e.target;
  const lineKey = select.dataset.lineKey;

  if (select.value === '__new__') {
    openModal(lineKey);
    return;
  }

  const selectedOption = select.options[select.selectedIndex];
  const address = JSON.parse(selectedOption.dataset.address);
  setLineAddress(lineKey, address);
}

function openModal(lineKey) {
  activeLineKeyForModal = lineKey;
  const overlay = document.getElementById('address-modal-overlay');
  if (!overlay) return;
  const modal = overlay.querySelector('.address-modal');
  modal.querySelectorAll('input').forEach((input) => (input.value = ''));
  overlay.hidden = false;
}

function closeModal() {
  const overlay = document.getElementById('address-modal-overlay');
  if (overlay) overlay.hidden = true;
  activeLineKeyForModal = null;
}

async function onSaveModalAddress() {
  if (!activeLineKeyForModal) return;
  const modal = document.querySelector('#address-modal-overlay .address-modal');
  const address = {};
  modal.querySelectorAll('input').forEach((input) => (address[input.name] = input.value));

  await setLineAddress(activeLineKeyForModal, address);
  closeModal();
}

async function setLineAddress(lineKey, address) {
  const displayLine = `${address.first_name || ''} ${address.last_name || ''} — ${address.address1}, ${address.city}, ${address.zip}`;

  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: lineKey,
      properties: {
        '_ship_address_id': address.id || '',
        '_ship_address': JSON.stringify(address),
        'Ship To': displayLine
      }
    })
  });

  document.dispatchEvent(new CustomEvent('cart:updated'));
}